import { t } from "i18next";
import React from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";
import "../css/cart.css";
import { FaTimes, FaCheck } from "react-icons/fa";

const MessageModal = ({
  show,
  title = "Message",
  message = "",
  type = "info",
  onConfirm = () => {},
  onCancel = () => {},
  showLinkButton = false,
  onClick = () => {},
}) => {
  return (
    <Modal
      show={show}
      onHide={onCancel}
      centered
      backdrop="static"
      className="custom-global-modal"
    >
      <Modal.Header closeButton className="select-delivery-address">
        <Modal.Title className="cart-header">{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ paddingBottom: "0px" }}>
        {/* <p>{message}</p> */}
        <p
          style={{
            fontFamily: "Outfit_400",
            fontWeight: "400",
            fontSize: "15px",
          }}
        >
          {message.split("\n").map((line, index) => (
            <React.Fragment key={index}>
              {line}
              {index < message.split("\n").length - 1 && <br />}
            </React.Fragment>
          ))}
        </p>
      </Modal.Body>

      <Modal.Footer>
        {showLinkButton ? (
          <Button
            variant="link"
            size="sm"
            className="change-address-link text-left"
            onClick={onClick}
          >
            🏠 {t("Change_delivery_address")}
          </Button>
        ) : null}
        {type === t("confirm") ? (
          <>
            <Button className="add-new-address-btn" onClick={onConfirm}>
              <FaCheck className="me-1" size={12} />
              {t("confirm")}
            </Button>
            <Button
              variant="danger"
              onClick={onCancel}
              style={{ fontFmily: "Outfit_400 !important" }}
            >
              <FaTimes className="me-2" size={12} />
              {t("close")}
            </Button>
          </>
        ) : (
          <Button variant="success" onClick={onCancel}>
            {t("ok")}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default MessageModal;
